<template>
  <NavBar v-if="!hideLayout" @switcher="modalOn = !modalOn" :isModalOn="modalOn" />
  <mainContent
    class="bg-white dark:bg-black"
    :class="{ 'overflow-hidden': modalOn }"
  >
    <RouterRender />
  </mainContent>
  <customFooter />
</template>

<script>
import NavBar from "./components/navBar";
import mainContent from "./components/mainContent";
import customFooter from "./components/footer";
import RouterRender from "./components/routerRender";
import accessiblity from "./accessiblity";
import { initSessionTracking } from "./analytics/tracker";
import { ref, computed } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "App",
  components: {
    NavBar,
    mainContent,
    customFooter,
    RouterRender,
  },
  mounted() {
    // Stores color mode as local item  --> 'theme'
    //* Color mode is defined by default in main.js
    localStorage.setItem("theme", this.colorMode);

    // Inits accessible listeners
    accessiblity();

    // Start active-time session tracking
    initSessionTracking();
  },
  setup() {
    let modalOn = ref(false);

    // Hide nav and footer for specific routes (e.g. login)
    const route = useRoute();
    const hideLayout = computed(() => !!(route.meta && route.meta.hideNavFooter)); // Check if the current route has meta.hideNavFooter set to true

    return { modalOn, hideLayout };
  },
};
</script>

<style src="./assets/tailwind.css"></style>
<style>
@import "./assets/utils.css";
@import "./assets/transitions.css";
</style>
